var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor p-3"},[_c('div',{staticClass:"canvasWrap",staticStyle:{"background":"url(img/toumei_bg.jpg)","line-height":"0"}},[_c('canvas',{attrs:{"id":"canvas","width":"1920","height":"1080"}})])])
}]

export { render, staticRenderFns }